import { ICreatedInstanceId, IFactory } from 'src/app/utils/IFactory';

export abstract class Factory<
    TInstance,
    TOptions extends ICreatedInstanceId,
> implements IFactory<TInstance> {
    abstract FACTORY_CLASS: string;

    public get createdInstanceId(): string {
        return this.options.createdInstanceId;
    }

    constructor(protected options: TOptions) {}
    create(): TInstance {
        // console.log(
        //     `Created instance ${this.options.createdInstanceId} from factory ${this.FACTORY_CLASS}`
        // );
        return this.getInstance(this.options);
    }

    protected abstract getInstance(options: TOptions): TInstance;
}
